import { graphql } from "../gql";

export const createThreadMutationDoc = graphql(`
  mutation createThread($caseId: ID!, $input: CreateThreadInput!) {
    createThread(caseId: $caseId, input: $input) {
      ...ThreadFragment
    }
  }
`);
